import { Link } from "@inertiajs/react"
import { cn } from "@/lib/cn"

// Shared cross-page link to an Appuser detail page (/appusers/:id).
// Renders the user's display label (name → email → "User #id") and
// styles it subtly: app-text by default, brand-red underline on hover.
//
// Defensive: when `id` is null/undefined we render plain text so callers
// don't have to guard. The label fallback chain matches the rest of the
// portal so the *visible* string is identical whether or not the link
// resolved.

type Props = {
  id: number | null | undefined
  name: string | null
  email?: string | null
  className?: string
}

function labelFor(name: string | null, email: string | null | undefined, id: number | null | undefined): string {
  if (name && name.trim().length > 0) return name
  if (email && email.trim().length > 0) return email
  if (id != null) return `User #${id}`
  return "Unknown"
}

export function UserLink({ id, name, email, className }: Props) {
  const label = labelFor(name, email, id)
  if (id == null) {
    return <span className={cn("text-app-text", className)}>{label}</span>
  }
  return (
    <Link
      href={`/appusers/${id}`}
      className={cn(
        "text-app-text transition hover:text-brand-red hover:underline",
        className,
      )}
    >
      {label}
    </Link>
  )
}
